<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedAssignmentCompanies"
      multi-select
      searchable
      class="tw-min-w-[250px]"
      :label="meta.filter.quickFilter ? '' : $t('Assignment companies')"
      :list="assignmentCompanies"
      :placeholder="$t('Select assignment companies to filter by')"
      :max-labels-visible="meta.filter.quickFilter ? 1 : 5"
      can-deselect
      labels-primary
    >
      <template #select-all-text>
        <WdsText :text="$t('Select all')" />
      </template>
    </WdsSelect>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack, WdsText } from '@worksome/wds-components'
import { computed, ComputedRef, ModelRef } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { ListItem } from '@/components/Workflows/Pages/Workflow/workflow'
import { useAccountsStore } from '@/components/GraphqlDataTable/filters/accounts/accounts-store'
import { graphql } from '@/gql'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

type AssignmentCompanyFilter = ListItem & { id: string }

const { meta } = defineProps<{ meta: FilterMetaDataProp }>()

const selectedAssignmentCompanies: ModelRef<AssignmentCompanyFilter[]> = defineModel({
  default: () => [],
})

const { selectedAccounts } = useAccountsStore()

const { result } = useQuery(
  graphql(`
    query AssignmentCompanies($accounts: [ID!]) {
      hires(accounts: $accounts, first: 100000) {
        data {
          company {
            id
            value: id
            label: name
          }
        }
      }
    }
  `),
  () => ({
    ...(selectedAccounts.length === 0
      ? {}
      : { accounts: selectedAccounts.map((account) => account.id) }),
  }),
  {
    clientId: 'publicApi',
  },
)

const assignmentCompanies: ComputedRef<AssignmentCompanyFilter[]> = computed(() => [
  ...new Set(result.value?.hires.data.map(({ company }) => company) ?? []),
])
</script>
